var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000001211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.11874 1.14706L1.08128 6.89586L15.6449 1.14706H8.11874Z",
    fill: "#F62578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.1901 6.88141L23.1711 1.14706H8.11874L1.08128 6.89586L15.8831 13.2972L30.186 6.90619C30.1884 6.9053 30.1905 6.90381 30.1921 6.90184C30.1937 6.89987 30.1948 6.89751 30.1952 6.895C30.1956 6.89248 30.1954 6.8899 30.1945 6.88751C30.1936 6.88512 30.1921 6.88302 30.1901 6.88141Z",
    fill: "#F58811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.6449 1.14706H8.11874L1.08128 6.89586L15.8811 13.2951L15.6449 1.14706Z",
    fill: "url(#paint0_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.6449 22.8248L22.9268 8.54988L19.407 2.00195L15.6449 1.14706H15.6429L11.8808 2.00195L8.3631 8.54988L15.6429 22.8248H15.6449Z",
    fill: "url(#paint1_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.6,
    d: "M8.36311 8.54979L11.8808 2.00186L7.84562 7.22203L1.08128 6.89577L15.6429 22.8247L8.36311 8.54979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.9268 8.54983H8.36311L1.08128 6.89581L15.6449 22.8248L30.1881 6.90407L22.9268 8.54983Z",
    fill: "url(#paint2_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.1711 1.14706L29.3358 7.08997L15.6449 22.8248L29.9971 6.94129L23.1711 1.14706Z",
    fill: "url(#paint3_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.7,
    d: "M14.2959 20.1735L9.71238 12.7892C8.64043 12.0851 5.133 10.6706 5.133 10.6706L14.2959 20.1735Z",
    fill: "url(#paint4_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M22.9268 8.54977H8.3631L9.17014 10.1356L15.6449 22.8247L22.9268 8.54977Z",
    fill: "url(#paint5_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.9269 8.54977H8.33242L19.863 9.96632L15.6533 22.7855L22.9269 8.54977Z",
    fill: "url(#paint6_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M19.407 2.00186L22.9267 8.54979L19.3926 15.4777L24.8098 8.12028L19.407 2.00186Z",
    fill: "#FFE4BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M19.4071 0.292236H11.8809L8.11884 1.14712L11.8809 2.00201H19.4071L23.1712 1.14712L19.4071 0.292236Z",
    fill: "#FFA348"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M19.407 2.00201L23.1712 1.14712L19.407 0.292236H16.0372C16.0372 0.292236 14.2691 0.928238 17.9716 2.00201H19.407Z",
    fill: "url(#paint7_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M11.0513 0.480164L8.11884 1.14714L11.8809 2.00203H16.4295C16.4295 2.00203 10.8336 1.65512 11.0513 0.480164Z",
    fill: "url(#paint8_linear_2052_5232)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.3,
    d: "M22.9186 5.24387H8.36933L1.09572 6.89582L8.36933 8.54984H22.9268L30.1861 6.89788L22.9186 5.24387Z",
    fill: "url(#paint9_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.4,
    d: "M12.2053 13.5738L15.0371 16.4441L15.4642 20.927L12.2053 13.5738Z",
    fill: "url(#paint10_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.4,
    d: "M18.676 17.8649L25.1919 10.9432L16.7704 21.3257L18.676 17.8649Z",
    fill: "url(#paint11_linear_2052_5232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M29.2867 7.07954C27.1551 7.52144 25.0235 7.99225 22.9207 8.54978C25.3542 8.0893 27.7794 7.53383 30.1759 6.89783L29.2867 7.07954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M22.4483 9.43151L21.9719 10.3132C21.6597 10.9017 21.3558 11.4923 21.0375 12.0829C20.7192 12.6735 20.4214 13.2682 20.1114 13.8608L19.1975 15.6428L18.2919 17.429C17.9942 18.0258 17.6923 18.6226 17.3966 19.2214C17.1009 19.8202 16.8052 20.4191 16.5115 21.0179L16.0762 21.9203L15.8585 22.3725L15.6531 22.8247L15.8934 22.3849L16.1316 21.945L16.606 21.0633C16.9181 20.4727 17.2323 19.8822 17.5403 19.2916C17.8484 18.701 18.1564 18.1063 18.4665 17.5137L19.3803 15.7337L20.2859 13.9455C20.5857 13.3487 20.8876 12.754 21.1813 12.1552C21.4749 11.5563 21.7747 10.9575 22.0663 10.3566L22.5017 9.45422L22.7152 9.00406L22.9309 8.54977L22.6885 8.98961L22.4483 9.43151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M22.3745 7.44314C22.1856 7.07558 21.9926 6.71215 21.7995 6.34872C21.6065 5.98529 21.4052 5.62393 21.204 5.26256C21.0028 4.9012 20.7933 4.54603 20.5879 4.19292C20.7673 4.56461 20.9514 4.93355 21.1403 5.29973C21.3293 5.66729 21.5223 6.03072 21.7153 6.39415C21.9084 6.75758 22.1096 7.11895 22.3109 7.48031C22.3909 7.62279 22.5265 7.93047 22.6353 8.1287C22.9413 8.68211 20.7687 8.50452 19.2901 8.49213L17.4686 8.47355L15.6492 8.46116C14.4356 8.46116 13.2219 8.46116 12.0083 8.46116H9.82743C9.6918 8.46139 9.55846 8.42599 9.44063 8.35844C9.32279 8.2909 9.22456 8.19356 9.15567 8.07608C9.08677 7.9586 9.0496 7.82505 9.04785 7.68868C9.04609 7.5523 9.07981 7.41783 9.14566 7.2986C10.1149 5.5434 11.8563 2.40262 11.8563 2.40262C11.9087 2.30885 11.9851 2.23088 12.0775 2.17678C12.1699 2.12268 12.2751 2.09442 12.382 2.09494C12.842 2.09494 13.302 2.09494 13.762 2.09494C14.3904 2.09494 15.0167 2.09494 15.6451 2.09494L16.5856 2.08255L17.5261 2.06397C18.1422 2.05158 18.7808 2.03299 19.4072 2.00615C18.7911 1.97724 18.1525 1.96072 17.5261 1.94627L16.5856 1.92768H15.6451C15.0167 1.92768 14.3904 1.92768 13.762 1.91736C13.1336 1.90703 12.5586 1.91736 11.9569 1.91736C11.9127 1.91777 11.8686 1.91292 11.8255 1.9029L10.9569 1.71706L10.0122 1.51056C9.69806 1.44655 9.38182 1.38254 9.06763 1.32266C8.75343 1.26277 8.43514 1.20082 8.11889 1.14301C8.42898 1.22767 8.73495 1.31027 9.0512 1.3908L9.9835 1.6324L10.9199 1.86367C11.0072 1.88482 11.0886 1.92569 11.1579 1.98317C11.2271 2.04066 11.2825 2.11325 11.3197 2.19545C11.3569 2.27764 11.375 2.36728 11.3726 2.45756C11.3702 2.54784 11.3475 2.63639 11.306 2.71649L8.43103 8.29183C8.40723 8.33842 8.36866 8.3757 8.32143 8.39776C8.27419 8.41983 8.22098 8.42542 8.17023 8.41366L6.55821 8.05643L4.73262 7.65996L3.82085 7.45347L2.90703 7.26143C0.95617 6.80094 1.97061 6.32394 2.9522 5.58469C5.26037 3.86253 8.11889 1.14713 8.11889 1.14713L7.22561 1.84922L6.33437 2.55542C5.74295 3.02623 5.14743 3.49497 4.55601 3.96784L2.78381 5.38852L1.03831 6.79475C1.02398 6.80628 1.01216 6.82067 1.00361 6.837C0.995053 6.85334 0.989941 6.87127 0.988592 6.88968C0.987242 6.90809 0.989685 6.92659 0.995766 6.94401C1.00185 6.96143 1.01144 6.9774 1.02394 6.99092L2.81462 8.96707L4.63199 10.9618L6.45348 12.9524L8.27907 14.9368C9.49613 16.2611 10.7187 17.5806 11.9467 18.8953L12.8584 19.8803L13.7825 20.8632C14.3986 21.5178 15.0147 22.1744 15.6307 22.8249C15.0372 22.1476 10.1478 16.1345 5.33019 11.222C4.30343 10.1647 1.16974 7.00124 1.16974 7.00124C1.76732 7.15199 2.2807 7.19741 2.88033 7.34402L3.78594 7.56497L4.6936 7.78179L6.51098 8.21336C6.51098 8.21336 8.32425 8.66146 8.34067 8.71927C10.3246 13.6425 12.7683 18.3655 15.6389 22.8249L8.58915 8.9299C8.57524 8.8972 8.56997 8.86143 8.57384 8.82608C8.57772 8.79073 8.59061 8.75698 8.61126 8.7281C8.63192 8.69923 8.65964 8.67621 8.69175 8.66128C8.72385 8.64635 8.75925 8.64001 8.7945 8.64287C9.89725 8.68417 10.8932 8.64287 11.998 8.64287C13.2117 8.64287 14.4253 8.64287 15.6389 8.63255L17.4584 8.62016L19.2798 8.60364C19.8959 8.60364 20.4935 8.58712 21.0993 8.57679C21.7051 8.56647 22.3129 8.55821 22.9208 8.54375C22.9208 8.54995 22.5634 7.81483 22.3745 7.44314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M21.3004 1.61996C21.6125 1.54768 21.9165 1.47541 22.2389 1.39488C22.5613 1.31434 22.8549 1.23381 23.1712 1.14502C22.8529 1.19664 22.5366 1.25446 22.2204 1.32054C21.9042 1.38662 21.592 1.4527 21.2778 1.52703C20.9636 1.60137 20.6515 1.67364 20.3394 1.75211C20.0272 1.83058 19.7233 1.91318 19.4071 2.00404C19.7254 1.95035 20.0416 1.89253 20.3558 1.82645C20.67 1.76037 20.9862 1.69223 21.3004 1.61996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.7,
    d: "M8.63828 8.65512C8.60793 8.64888 8.58008 8.63381 8.55817 8.61178C8.53627 8.58976 8.52128 8.56174 8.51507 8.53123L8.43087 6.92264L8.34052 8.53123C8.33431 8.56174 8.31932 8.58976 8.29742 8.61178C8.27551 8.63381 8.24766 8.64888 8.21731 8.65512L6.93385 8.73979L8.21731 8.82238C8.24755 8.82887 8.27527 8.84403 8.29713 8.86601C8.319 8.888 8.33406 8.91587 8.34052 8.94628L8.42266 10.5569L8.50685 8.94628C8.51331 8.91587 8.52838 8.888 8.55024 8.86601C8.5721 8.84403 8.59983 8.82887 8.63007 8.82238L9.91353 8.73979L8.63828 8.65512Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2052_5232",
    x1: 8.48221,
    y1: 13.2951,
    x2: 8.48221,
    y2: 1.14706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F9F6CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F4FBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FDB14F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2052_5232",
    x1: 15.6449,
    y1: 1.14706,
    x2: 15.6449,
    y2: 22.8248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FED297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FCC34F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F79720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2052_5232",
    x1: 15.8298,
    y1: 7.32119,
    x2: 21.7213,
    y2: 19.8861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F39411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D36F03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#CC6600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2052_5232",
    x1: 15.6449,
    y1: 11.9859,
    x2: 29.9971,
    y2: 11.9859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F39412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D46F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B94F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2052_5232",
    x1: 5.133,
    y1: 15.422,
    x2: 14.2897,
    y2: 15.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F9F6CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F4FBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FDB14F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2052_5232",
    x1: 15.6449,
    y1: 8.54977,
    x2: 15.6449,
    y2: 22.8247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F19515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CB7114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#903812"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#671210"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2052_5232",
    x1: 8.00796,
    y1: 9.11763,
    x2: 19.661,
    y2: 15.8079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F39412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D46F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B94F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2052_5232",
    x1: 15.6142,
    y1: 1.14712,
    x2: 23.1712,
    y2: 1.14712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FDB14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F4FBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F9F6CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2052_5232",
    x1: 8.11884,
    y1: 1.24006,
    x2: 16.4295,
    y2: 1.24006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7B2574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#944473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#BC7571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F2B86F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC76F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2052_5232",
    x1: 4.73047,
    y1: 0.562644,
    x2: 26.6116,
    y2: 13.1261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC76F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F6BB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#C6783B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A3471B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8E2807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#861D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2052_5232",
    x1: 12.2053,
    y1: 17.2515,
    x2: 15.4642,
    y2: 17.2515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFE1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2052_5232",
    x1: 16.7704,
    y1: 16.1345,
    x2: 25.1919,
    y2: 16.1345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD4DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFE1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.80bf6e5f1f3357ad1f8b2b1fc3e350c1.svg";
export { ForwardRef as ReactComponent };